import { BrowserRouter } from 'react-router';

import { App, reportWebVitals } from '@app';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

reportWebVitals();
